var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHorizm = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 28,
    viewBox: "0 0 111 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_92)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2699_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.594514H17.0412V27.2492H0V0.594514Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2699_92)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.240115 27.0049C0.0797812 26.8421 0 26.6358 0 26.3853V1.45836C0 1.1828 0.0797812 0.970268 0.240115 0.820358C0.400062 0.670056 0.603177 0.594514 0.850229 0.594514H2.5503C2.82125 0.594514 3.03092 0.670056 3.17892 0.820358C3.32692 0.970268 3.40092 1.1828 3.40092 1.45836V10.2052C4.11548 9.27952 4.95877 8.57224 5.9331 8.08416C6.90628 7.59646 8.10763 7.35222 9.53714 7.35222C11.9032 7.35222 13.7447 8.12173 15.0636 9.66076C16.3817 11.2002 17.0412 13.2336 17.0412 15.7613V26.3853C17.0412 26.6358 16.961 26.8421 16.8011 27.0049C16.6404 27.1682 16.4369 27.2492 16.191 27.2492H14.4535C14.2068 27.2492 14.0037 27.1682 13.8438 27.0049C13.6831 26.8421 13.6033 26.6358 13.6033 26.3853V15.9867C13.6033 14.1847 13.172 12.7834 12.3094 11.7818C11.4465 10.7814 10.2028 10.2804 8.57591 10.2804C6.9984 10.2804 5.74155 10.7872 4.80537 11.801C3.86843 12.8144 3.40092 14.2097 3.40092 15.9867V26.3853C3.40092 26.6358 3.32036 26.8421 3.16042 27.0049C2.9997 27.1682 2.79658 27.2492 2.5503 27.2492H0.850229C0.603177 27.2492 0.400062 27.1682 0.240115 27.0049Z",
    fill: "#071227"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0452 27.0049C42.8845 26.8421 42.8047 26.6358 42.8047 26.3853V8.62861C42.8047 8.37889 42.8845 8.16596 43.0452 7.99022C43.2051 7.81565 43.4082 7.72758 43.6549 7.72758H45.2074C45.4783 7.72758 45.6938 7.80939 45.8545 7.97143C46.0144 8.13465 46.095 8.35345 46.095 8.62861V10.2804C47.1048 8.57851 48.8183 7.72758 51.233 7.72758H52.6748C52.9454 7.72758 53.155 7.80273 53.303 7.95303C53.451 8.10294 53.5247 8.31587 53.5247 8.59103V9.97976C53.5247 10.2307 53.451 10.4369 53.303 10.5994C53.155 10.7626 52.9454 10.8436 52.6748 10.8436H50.5681C49.2122 10.8436 48.1462 11.244 47.3703 12.0448C46.5937 12.8461 46.2056 13.9346 46.2056 15.3108V26.3853C46.2056 26.6358 46.1193 26.8421 45.947 27.0049C45.7743 27.1682 45.5647 27.2492 45.3184 27.2492H43.6549C43.4082 27.2492 43.2051 27.1682 43.0452 27.0049Z",
    fill: "#071227"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2699_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 0,
    width: 4,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0391 0.331917H59.9576V27.2492H56.0391V0.331917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2699_92)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5752 27.0049C56.4148 26.8421 56.3351 26.6358 56.3351 26.3853V8.59103C56.3351 8.34092 56.4148 8.13464 56.5752 7.97142C56.7351 7.80938 56.9382 7.72758 57.1849 7.72758H58.8117C59.0576 7.72758 59.2611 7.80938 59.4219 7.97142C59.5814 8.13464 59.662 8.34092 59.662 8.59103V26.3853C59.662 26.6358 59.5814 26.8421 59.4219 27.0049C59.2611 27.1681 59.0576 27.2492 58.8117 27.2492H57.1849C56.9382 27.2492 56.7351 27.1681 56.5752 27.0049ZM56.2796 3.80447C56.1188 3.64203 56.0391 3.43537 56.0391 3.18526V1.2329C56.0391 0.983182 56.1188 0.770255 56.2796 0.594511C56.4391 0.419942 56.643 0.331875 56.8893 0.331875H59.0707C59.3163 0.331875 59.5259 0.419942 59.6986 0.594511C59.8709 0.770255 59.9576 0.983182 59.9576 1.2329V3.18526C59.9576 3.43537 59.8709 3.64203 59.6986 3.80447C59.5259 3.96769 59.3163 4.04871 59.0707 4.04871H56.8893C56.643 4.04871 56.4391 3.96769 56.2796 3.80447Z",
    fill: "#071227"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8225 27.0049C63.6618 26.8421 63.582 26.6358 63.582 26.3853V25.1465C63.582 24.9465 63.6379 24.7398 63.7489 24.5273C63.8595 24.3148 63.9759 24.1206 64.1 23.9453L74.4134 10.6181H64.7649C64.5186 10.6181 64.3216 10.5371 64.1736 10.3743C64.0256 10.2119 63.952 10.0052 63.952 9.7547V8.59103C63.952 8.34092 64.0256 8.13465 64.1736 7.97143C64.3216 7.80939 64.5186 7.72758 64.7649 7.72758H77.8509C78.0972 7.72758 78.3003 7.80939 78.4607 7.97143C78.621 8.13465 78.7012 8.34092 78.7012 8.59103V9.905C78.7012 10.1806 78.5285 10.568 78.1839 11.0687L68.0182 24.3582H78.5902C78.8619 24.3582 79.0708 24.4334 79.2188 24.5833C79.3668 24.7336 79.4404 24.9465 79.4404 25.2217V26.3853C79.4404 26.6358 79.3602 26.8421 79.2003 27.0049C79.0396 27.1682 78.8364 27.2492 78.5902 27.2492H64.4323C64.1856 27.2492 63.9825 27.1682 63.8225 27.0049Z",
    fill: "#071227"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2699_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 7,
    width: 28,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2109 7.35222H110.677V27.2492H83.2109V7.35222Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2699_92)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4511 27.0049C83.2907 26.8421 83.2109 26.6358 83.2109 26.3853V8.59103C83.2109 8.34092 83.2907 8.13465 83.4511 7.97143C83.611 7.80939 83.8141 7.72758 84.0608 7.72758H85.6136C85.8595 7.72758 86.0572 7.80939 86.2052 7.97143C86.3529 8.13465 86.4269 8.34092 86.4269 8.59103V9.86742C87.7577 8.19101 89.5564 7.35222 91.8238 7.35222C94.5345 7.35222 96.4566 8.50375 97.5912 10.806C98.1821 9.7547 99.0261 8.91669 100.123 8.29043C101.219 7.66535 102.445 7.35222 103.801 7.35222C105.821 7.35222 107.473 8.05324 108.754 9.45448C110.036 10.8565 110.677 12.8836 110.677 15.5362V26.3853C110.677 26.6358 110.596 26.8421 110.436 27.0049C110.276 27.1682 110.073 27.2492 109.827 27.2492H108.237C107.99 27.2492 107.787 27.1682 107.627 27.0049C107.467 26.8421 107.387 26.6358 107.387 26.3853V15.874C107.387 13.8719 106.98 12.439 106.167 11.5755C105.354 10.7121 104.282 10.2804 102.951 10.2804C101.768 10.2804 100.751 10.725 99.901 11.6131C99.0508 12.5016 98.6257 13.9217 98.6257 15.874V26.3853C98.6257 26.6358 98.5451 26.8421 98.3856 27.0049C98.2248 27.1682 98.0217 27.2492 97.7755 27.2492H96.1486C95.9023 27.2492 95.6988 27.1682 95.5389 27.0049C95.3785 26.8421 95.2988 26.6358 95.2988 26.3853V15.874C95.2988 13.8974 94.8736 12.4707 94.0234 11.5943C93.1732 10.7183 92.1195 10.2804 90.8626 10.2804C89.6798 10.2804 88.663 10.7183 87.8128 11.5943C86.9626 12.4707 86.5379 13.8845 86.5379 15.8364V26.3853C86.5379 26.6358 86.4573 26.8421 86.2977 27.0049C86.137 27.1682 85.9335 27.2492 85.6876 27.2492H84.0608C83.8141 27.2492 83.611 27.1682 83.4511 27.0049Z",
    fill: "#071227"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2699_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 7,
    width: 20,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6506 13.4433C20.3659 14.1337 20.6874 14.9274 21.3681 15.2162C22.0491 15.5042 22.8314 15.1784 23.1161 14.4879C24.2441 11.751 26.8623 9.98197 29.787 9.98197C33.7718 9.98197 37.0139 13.2705 37.0139 17.3129C37.0139 21.3557 33.7718 24.6445 29.787 24.6445C29.3462 24.6445 28.9061 24.6041 28.4783 24.5247C27.7528 24.3912 27.0568 24.8773 26.9236 25.6137C26.7909 26.3501 27.2716 27.0565 27.9975 27.1908C28.5834 27.3002 29.1858 27.3547 29.787 27.3547C35.2444 27.3547 39.6858 22.8499 39.6858 17.3129C39.6858 11.7763 35.2444 7.27146 29.787 7.27146C25.7818 7.27146 22.1956 9.69395 20.6506 13.4433Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2699_92)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6506 13.4433C20.3659 14.1337 20.6874 14.9274 21.3681 15.2162C22.0491 15.5042 22.8314 15.1784 23.1161 14.4879C24.2441 11.751 26.8623 9.98197 29.787 9.98197C33.7718 9.98197 37.0139 13.2705 37.0139 17.3129C37.0139 21.3557 33.7718 24.6445 29.787 24.6445C29.3462 24.6445 28.9061 24.6041 28.4783 24.5247C27.7528 24.3912 27.0568 24.8773 26.9236 25.6137C26.7909 26.3501 27.2716 27.0565 27.9975 27.1908C28.5834 27.3002 29.1858 27.3547 29.787 27.3547C35.2444 27.3547 39.6858 22.8499 39.6858 17.3129C39.6858 11.7763 35.2444 7.27146 29.787 7.27146C25.7818 7.27146 22.1956 9.69395 20.6506 13.4433Z",
    fill: "url(#paint0_linear_2699_92)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3516 14.9423C28.0746 14.9423 27.0391 15.9775 27.0391 17.2546C27.0391 18.5321 28.0746 19.5673 29.3516 19.5673C30.6285 19.5673 31.6641 18.5321 31.6641 17.2546V14.9423H29.3516Z",
    fill: "#071227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2699_92",
    x1: 968.442,
    y1: 7.2715,
    x2: 968.442,
    y2: 2015.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F61A52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 27.75,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHorizm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/horizm.ba0aadee.svg";
export { ForwardRef as ReactComponent };